import React, { useEffect, useState } from "react";
import { StyleSheet, SafeAreaView, Dimensions, ScrollView } from "react-native";
import { useTheme } from "@react-navigation/native";
import { useAuthContext } from "../../../hooks/useAuthContext";
import CustomSurvey from "../../../components/SurveyBuilderComponent/Survey/CustomSurvey";
import { loadSurvey } from "../../../services/SurveyService";
import { generateUniqueID } from "../../../components/SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions";
import { useSafeAreaInsets } from "react-native-safe-area-context";

// * Language
import { useTranslation } from "react-i18next";

const ResponseScreen = (props) => {
  const { t } = useTranslation();
  const { user, clientApi } = useAuthContext();
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  const insets = useSafeAreaInsets();
  // * Get ID of Survey to load
  const survId = props.survId;
  // TODO Change organization id when you want to support multiCple companies
  const [survey, setSurvey] = useState({});
  // * state array of section each section contains array of questions
  const [sectionQuestionList, setSectionQuestionList] = useState([]);
  const [questionOptionResponseList, setQuestionOptionResponseList] = useState(
    []
  );
  const [userSurveySectionList, setUserSurveySectionList] = useState([]);

  // * Load selectd Survey to the screen
  useEffect(() => {
    // console.log("Use Effect Loaded for Edit Survey");
    // console.log(survId)

    loadSurvey(clientApi, survId, user.token)
      .then((respSurvey) => {
        setSurvey(respSurvey.sh);
        setSectionQuestionList(respSurvey.ss);

        // * Create empty response map based on question options
        // * Create empty user survey sections based on sections
        const questionStateTemp = [];
        const userSurvSectionTemp = [];

        respSurvey.ss.map((sectionItr) => {
          userSurvSectionTemp.push({
            id: generateUniqueID(),
            user_id:
              respSurvey.sh.require_login === true ? user.userId : "noLogin", // log in not required -> set user_id to 'noLogin' and generate random id later on
            survey_section_id: sectionItr.id,
            completed_on: "1900-01-01",
          });
          sectionItr.section_questions.map((questionItr) =>
            questionItr.question_options.map((questionOptionsItr) => {
              questionStateTemp.push({
                id: generateUniqueID(),
                user_id:
                  respSurvey.sh.require_login === true
                    ? user.userId
                    : "noLogin", // log in not required -> set user_id to 'noLogin' and generate random id later on
                question_option_id: questionOptionsItr.id,
                answer_numeric: 0,
                answer_text: "",
                answer_yn: 2,
                unit_of_measure_id: "E9CDA0B2-20D9-44DC-87E7-19B0B1268ED1",
              });
            })
          );
        });
        // ! Set state outside the loop beacuse if you set it on state it will only add the last
        setQuestionOptionResponseList(questionStateTemp);
        setUserSurveySectionList(userSurvSectionTemp);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <SafeAreaView style={[styles.main, {paddingBottom: Math.max(insets.bottom + 24, 40)}]}>
      <ScrollView>
        <CustomSurvey
          survey={survey}
          setSurvey={setSurvey}
          sectionQuestionList={sectionQuestionList}
          setSectionQuestionList={setSectionQuestionList}
          questionOptionResponseList={questionOptionResponseList}
          setQuestionOptionResponseList={setQuestionOptionResponseList}
          userSurveySectionList={userSurveySectionList}
          isEdit={0}
          isResponse={1}
          setShowMyAssessments={props.setShowMyAssessments}
          setShowEditScreen={props.setShowEditScreen}
          setShowResponseScreen={props.setShowResponseScreen}
          setShowMySurveys={props.setShowMySurveys}
          setShowCreateScreen={props.setShowCreateScreen}
          setShowSurveysAdmin={props.setShowSurveysAdmin}
        />
      </ScrollView>
    </SafeAreaView>
  );
};

const makeStyles = (colors) =>
  StyleSheet.create({
    main: {
      flex: 1,
    },
  });

export default ResponseScreen;
